export default "__VITE_ASSET__jifIAEZf__"